// extracted by mini-css-extract-plugin
export default {"scoringContainer":"oERMBkPn156kYI65gsK8","title":"UydlqUAxEjXsH0ZifC3z","siderContainer":"ZYhwPL8q3lnod89DNvQH","info":"BbHdhsaWFXbkxjQ4_QoF","buttons":"oJ_OkC_VVstovtV8v_7Z"};